import { makeStyles } from 'tss-react/mui';

export const useFileMessagesStyles = makeStyles()({
  button: {
    borderRadius: '16px',
  },
});
